import { useDispatch, useSelector } from "react-redux";
import { ProjectFilterInput } from "../../../api/psc";
import { RootState } from "../../../slices/Store";
import { reloadMap, resetMapFilter, setMapFilter } from "../slice/MapSlice";
import ProjectFilter from "./ProjectFilter";

export default function MapFilter() {
    const dispatch = useDispatch();

    const mapState = useSelector((r: RootState) => r.map);

    const reload = () => {
        dispatch(reloadMap());
    };

    const handleFilterChange = (filter: ProjectFilterInput) => {
        dispatch(setMapFilter(filter));
    };

    const handleClearFilters = () => {
        dispatch(resetMapFilter());
    };

    return (
        <ProjectFilter
            reloadCallback={reload}
            isLoading={mapState.isLoading}
            filter={mapState.filter}
            onFilterChange={handleFilterChange}
            clearFilters={handleClearFilters}
            hasAnyFilter={mapState.hasAnyFilter}
        />
    );
}
